import { NgModule } from '@angular/core';
import { WidgetSearchBarComponent } from './widget-search-bar/widget-search-bar.component';

/**
 * Transitional shim: WidgetSearchBarComponent is now standalone. This NgModule
 * keeps existing consumers (ui-navigation) green until they migrate to importing
 * the standalone component directly. Removed in the P1k bootstrap step.
 */
@NgModule({
  imports: [WidgetSearchBarComponent],
  exports: [WidgetSearchBarComponent],
})
export class SearchModule {}
